// extracted by mini-css-extract-plugin
export default {"wrapper":"NewPost_wrapper__sZSrO","contentEditable":"NewPost_contentEditable__mD7SQ"};